import { render, staticRenderFns } from "./templateselection.vue?vue&type=template&id=ded230a0&scoped=true&"
import script from "./templateselection.vue?vue&type=script&lang=js&"
export * from "./templateselection.vue?vue&type=script&lang=js&"
import style0 from "./templateselection.vue?vue&type=style&index=0&id=ded230a0&scoped=true&lang=css&"
import style1 from "./templateselection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded230a0",
  null
  
)

export default component.exports